/**
 * The onboarding copy that states what a plan includes and what the step-by-step tools screen is called.
 * One source for every surface that shows it (the AI account step, the guided "Your team" and tools screens).
 */

/** The AI members the Free plan includes, the COO counted (the 5 Oct decision). Must equal the API's Free limit. */
export const FREE_PLAN_AI_MEMBERS = 2

/** "Free: your COO plus 1 teammate": the plan's name, then the COO and the teammates the plan includes besides. */
export function planLine(planName: string, includedAiMembers: number): string {
    // The count includes the COO, so the teammates are the rest.
    const teammates = includedAiMembers - 1
    return `${planName}: your COO plus ${teammates} ${teammates === 1 ? 'teammate' : 'teammates'}`
}

/** The Free plan's line. */
export const FREE_PLAN_LINE = planLine('Free', FREE_PLAN_AI_MEMBERS)

/**
 * The Free line, then the upgrade sentence. Shown on the AI account step, right after the AI-account notice: #1933's
 * approved design keeps the sign-in and sign-up screen clear of plan copy. The name is kept from when it sat there.
 */
export const SIGN_UP_PLAN_LINE = `${FREE_PLAN_LINE}. Upgrade any time for a bigger team.`

/** The heading of the step-by-step tools screen. */
export const TOOLS_SCREEN_TITLE = 'Connect the tools your team needs'
